module.exports = __webpack_public_path__ + "img/max-file-search--xml.17038107.svg";